import { render, staticRenderFns } from "./ProductFinder.vue?vue&type=template&id=31ad4f06&scoped=true"
import script from "./ProductFinder.vue?vue&type=script&lang=js"
export * from "./ProductFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad4f06",
  null
  
)

export default component.exports